// Small shared pieces of the phone floor sale.
import React, { useState } from "react";
import { initials } from "./floorHelpers";
import GarmentArt from "../GarmentArt";

// art/colour: the style's drawn garment, shown when there is no photo.
export function FloorImage({ src, alt, className = "", art, colour }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className={`fp-fl-img ${className}`.trim()}>
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" onError={() => setFailed(true)} />
      ) : art ? (
        <GarmentArt art={art} colour={colour} />
      ) : (
        <span className="fp-fl-img-ini" aria-hidden="true">
          {initials(alt)}
        </span>
      )}
    </span>
  );
}

export function BagButton({ count, onClick }) {
  return (
    <button type="button" className="fp-fl-bagbtn" aria-label={`Bag, ${count} ${count === 1 ? "item" : "items"}`} onClick={onClick}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M5 8h14l-1 12H6zM9 8V6a3 3 0 0 1 6 0v2" />
      </svg>
      {count > 0 && <span className="fp-fl-ct fp-num">{count}</span>}
    </button>
  );
}

export function Header({ children }) {
  return <header className="fp-fl-hd">{children}</header>;
}

export function Back({ onClick, children }) {
  return (
    <button type="button" className="fp-fl-back" onClick={onClick}>
      ‹ {children}
    </button>
  );
}
